global.App = {
  DOMAIN_WITH_PROTOCOL: "https://www.waitlistr.com",
  DEV_DOMAIN_WITH_PROTOCOL: "http://localhost:3010",
};
